import React from 'react'
import PortalSubmissions from '../notifications/PortalSubmissions'




const PublicSubmission = () => {

  const maincardtitle = (<div className='text-center mt-2'>Uprocessed Portal Submission</div>);
  
  return (
    <PortalSubmissions
    maincardtitlex={maincardtitle }
    />
  )
}

export default PublicSubmission